export default __webpack_public_path__ + "static/media/Untitled-3.c6553b4c.jpg";